<template>
  <div class="column is-11-mobile is-7-tablet is-5-widescreen is-5-fullhd is-5-desktop">
    <div class="order-details" v-if="vg_order.id">
      <div class="order-info is-flex justify-content-between">
        <div class="order-id">
          Order
          <span class="id" v-if="vg_order">#{{vg_order.id}}</span>
        </div>
        <div class="order-timestamp">
          <span class="order-time" v-if="vg_order">{{orderTime(vg_order)}}, </span>
          <span class="order-date" v-if="vg_order">{{orderDate(vg_order)}}</span>
        </div>
      </div>
      <div class="order-store is-flex">
     
        <img v-if="vg_order.location.images && getStorefeaturedImage(vg_order.location.images)" :src="getStorefeaturedImage(vg_order.location.images)" alt class="order-history-img is-block mr20" />
        <img v-else src="@/assets/img/icon-marker-green.svg" alt class="is-block mr20" />

        <div class="store-detail">
          <div class="store-name has-text-weight-semibold is-uppercase">
            <p class="text-dark">{{vg_order.location.display_name}}</p>
          </div>
          <div class="store-address" v-if="vg_order.location.address">
            <p>{{vg_order.location.address.formatted_address}}</p>
          </div>
        </div>
      </div>

      <div  class="order-item">
        <table class="cart-table order-show">
          <tr v-bind:key="'cart-item_' + index" v-for="(product, index) in vg_order.order_items">
            <td class="td-product-name is-size-15"><div class="order-srno">{{ index + 1}}</div> {{ product.product_name }}</td>
            <td  class="td-product-info text-right is-size-13">{{  product.weight ? product.weight : '0.00' }}{{ product.weighting_unit ? product.weighting_unit : '' }} X {{ product.unit }}</td>
            <td class="td-product-price text-right is-size-13">$ {{ (product.unit * product.price).toFixed(2) }}</td>
          </tr>
        </table>
      </div>

      <!-- <div
        class="order-item"
        v-for="(product, index) in order.order_items"
        :key="'product'+index"
      >
        <div class="order-item-left">
          <div class="order-srno">{{ index + 1}}</div>
          <div class="order-product-name">
            {{product.product_name}} X {{ product.unit }}
          </div>
        </div>
        <div class="order-item-right">
          <div class="order-weight" v-if="product.weight">{{product.weight.toFixed(2)}}g</div>
          <div class="order-price order-record-price" v-if="product.price">$ {{product.price.toFixed(2)}}</div>
        </div>
      </div> -->
      <div class="order-subtotal has-text-right">
        Subtotal
        <span class="subtotal-price order-record-price">
          $ {{ subtotal }}
        </span>
      </div>
      <div class="order-subtotal has-text-right" v-if="vg_order.deposit">
        Deposit
        <span class="subtotal-price order-record-price">
          $ {{ vg_order.deposit.toFixed(2) }}
        </span>
      </div>
      <div class="order-subtotal has-text-right" v-if="promoCodeDiscount">
        Promo Code: {{ vg_order.order_promocodes[0].code}}
        <span class="subtotal-price order-record-price">
         - $ {{ promoCodeDiscount }}
        </span>
      </div>
      <div class="order-subtotal has-text-right" v-if="loyaltyDiscount">
        Points Used: {{ new Intl.NumberFormat().format(vg_order.order_loyalty[0].points_redeemed) }}
        <span class="subtotal-price order-record-price">
         - $ {{ loyaltyDiscount }}
        </span>
      </div>
      <div class="order-tax has-text-right">
        Tax
        <span class="tax-price text-dark order-record-price">$ {{ vg_order.tax ? vg_order.tax.toFixed(2) : '0.00'}}</span>
      </div>
      <div class="order-tax has-text-right" v-if="vg_order.order_receive_method == 'delivery'">
        Delivery fee
        <span class="tax-price text-dark order-record-price">$ {{ vg_order.delivery_fee ? vg_order.delivery_fee.toFixed(2) : '0.00'}}</span>
      </div>
      <div class="order-tax has-text-right" v-if="vg_order.order_receive_method == 'delivery'">
       Tip
        <span class="tax-price text-dark order-record-price">$ {{ vg_order.tip ? vg_order.tip.toFixed(2) : '0.00'}}</span>
      </div>
      <div class="order-total has-text-right">
        Total
        <span class="total-price order-record-price">$ {{vg_order.total ? vg_order.total.toFixed(2) : '0.00'}}</span>
      </div>
      <div class="order-total has-text-right" v-if="vg_order.order_loyalty && (vg_order.order_loyalty.length > 0) && (vg_order.order_loyalty[0].points_earned > 0)">
        Points Earned
        <span class="total-price order-record-price">{{ new Intl.NumberFormat().format(vg_order.order_loyalty[0].points_earned) }}</span>
      </div>
      <div class="order-status-block is-flex justify-content-between align-items-center">
        <a href="#" @click.prevent="orderReceipt()"><strong>View Receipt</strong></a>
        <div class="order-status">
          <div class="status-text">Status</div>
          <div class="status">{{ucFirst(vg_order.status)}}</div>
        </div>
    
        <router-link
          class="button bg-secondary text-white hover-opacity-7 view-status"
          :to="{ 
            name: 'UserOrderStatus', 
            params: { 
              business_slug: $route.params.business_slug 
            },
            query: $route.query 
          }"
        >View Status</router-link>
      </div>
    </div>
    <div class="order-details" v-else>
       <div class="order-info is-flex justify-content-between">
         <p>{{ comingOrders.length > 0 ? 'Please select coming order from left bar.' : 'No order available.' }}</p>
       </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters } from "vuex";
import moment from 'moment';
import 'moment-timezone';

export default {
  props: ["review"],
  computed: {
    ...mapGetters({
      vg_order: "orderhistory/currentOrder",
      vg_allOrders: "orderhistory/allOrders",
    }),

    promoCodeDiscount() {
      if( this.vg_order.order_promocodes && (this.vg_order.order_promocodes.length > 0) ){
       return this.vg_order.order_promocodes[0].code ? this.vg_order.order_promocodes[0].applied_value.toFixed(2) : 0;
      }
      return 0;
    },

    loyaltyDiscount() {
      if( this.vg_order.order_loyalty && (this.vg_order.order_loyalty.length > 0) && (this.vg_order.order_loyalty[0].reward_amount > 0) ){
       return this.vg_order.order_loyalty[0].reward_amount.toFixed(2);
      }
      return 0;
    },

    subtotal () {
      return this.vg_order.sub_total ? this.vg_order.sub_total.toFixed(2) : '0.00';
    },

    comingOrders(){
      if (!this.vg_allOrders.orders) return [];
      return _.filter(this.vg_allOrders.orders, function(order) {
        return order.status =='pending' || order.status =='ready' || order.status =='preparing';
      });
    },
  },
  methods: {
      /**
     * Get store featured image
     */
    getStorefeaturedImage(images) {
      return Helpers.getStoreFeaturedImage(images);
    },

    // get order time and date
    orderTime(order) {
      if (!order) return;
      //return format(new Date(order.receive_time), "h:mm a");
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ?  order.location.address.timezone_id : 'America/Toronto').format('h:mm a');
    },

    // get order date
    orderDate(order) {
      if (!order) return;
      //return format(new Date(order.receive_time), "MMM d yyyy");
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('MMM DD YYYY');
    },

    // text to set first letter capital
    ucFirst(text) {
      if (!text) return;
      return _.upperFirst(text);
    },
    /**
     * Show order receipt details
     */
    orderReceipt() {
  
      bus.$emit("show-modal-order-recepit", {
        order: this.vg_order,
        modal: true
      });
    }
  }
};
</script>

<style scoped>
.order-history-img {
  object-fit: contain;
}
</style>